import SonBannerTabs from '../SonBannerTabs/src/index.vue'

export default SonBannerTabs